/**
 * resources/scripts/app.js
 */

